module.exports = __webpack_public_path__ + "img/tente_outra_vez_paizao_premiado.05eb0c46.png";